import { useHotKeys } from 'Hooks'
import { useSpreadSheetData } from '../SpreadSheetDataProvider'
import WeaverService from 'Services/WeaverService'
import { setEdits, setSelection, setSelectionType } from '../SpreadSheetDataProvider/actions'
import { emptyCell, selectionTypes } from '../helpers'

export default MultiColSelectShortcuts = ->

  [{
    columns,
    count,
    edits,
    selection,
    selectionType
  }, dispatch] = useSpreadSheetData()

  useHotKeys([{
    sequence: ['down', 'enter']
    fn: ->
      dispatch(setSelectionType(selectionTypes.CELL))
      dispatch(setSelection([selection[0], 0]))
    temporary: true
    watchers: [selection]
  }])

  useHotKeys([{
    sequence: 'left'
    fn: ->
      if selection[1] > 0
        dispatch(setSelectionType(selectionTypes.COL))
        dispatch(setSelection(selection[1] - 1))
    temporary: true
    watchers: [selection]
  }])

  useHotKeys([{
    sequence: ['right', 'tab']
    fn: ->
      dispatch(setSelectionType(selectionTypes.COL))
      dispatch(setSelection(selection[1] + 1))
    temporary: true
    watchers: [selection]
  }])

  useHotKeys([{
    sequence: 'shift+left'
    fn: ->
      if selection[1] > 0
        dispatch(setSelection([selection[0], selection[1] - 1]))
    temporary: true
    watchers: [selection]
  }])

  useHotKeys([{
    sequence: 'shift+right'
    fn: ->
      dispatch(setSelection([selection[0], selection[1] + 1]))
    temporary: true
    watchers: [selection]
  }])

  useHotKeys([{
    sequence: 'backspace'
    fn: ->
      newEdits = [0..(count - 1)].reduce((acc, i) ->
        {
          acc...,
          [i]: ([selection[0]..selection[1]].reduce(((acc, j) ->
            {
              edits[i]...,
              acc...,
              [j]: emptyCell(columns[j])
            }
          ), {}))
        }
      , edits)
      dispatch(setEdits({
        prevEdits: edits
        nextEdits: newEdits
      }))
    temporary: true
    expr: WeaverService.userCanEdit()
    watchers: [selection, edits]
  }])

  <div />





